// Set the date we're counting down to
const countDownDate = new Date("Oct 17, 2025 08:00:00").getTime();

// Update the countdown every 1 second
const x = setInterval(function() {
  // Get today's date and time
  const now = new Date().getTime();

  // Find the distance between now and the countdown date
  const distance = countDownDate - now;

  // Time calculations for days, hours, minutes and seconds
  const days = Math.floor(distance / (1000 * 60 * 60 * 24));
  const hours = Math.floor(
    (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
  );
  const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
  const seconds = Math.floor((distance % (1000 * 60)) / 1000);

  const counter = document.getElementById("counter");

  if (counter) {
    counter.innerHTML = `
    <div>${days} <small>dager</small></div>
    <div>${hours} <small>timer</small></div>
    <div>${minutes} <small>minutter</small></div>
    <div>${seconds} <small>sekunder</small></div>
  `;

    if (distance < 0) {
      clearInterval(x);
      counter.innerHTML = `
      <div>0 <small>dager</small></div>
      <div>0 <small>timer</small></div>
      <div>0 <small>minutter</small></div>
      <div>0 <small>sekunder</small></div>
    `;
    }
  }
}, 1000);
